import * as React from 'react';

function SvgArchive(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="#67667B"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.33317 2.5H16.6665L18.3332 5.83333V16.6667C18.3332 16.8877 18.2454 17.0996 18.0891 17.2559C17.9328 17.4122 17.7209 17.5 17.4998 17.5H2.49984C2.27882 17.5 2.06686 17.4122 1.91058 17.2559C1.7543 17.0996 1.6665 16.8877 1.6665 16.6667V5.83667L3.33317 2.5ZM10.8332 11.6667V8.33333H9.1665V11.6667H6.6665L9.99984 15L13.3332 11.6667H10.8332ZM16.4698 5.83333L15.6365 4.16667H4.364L3.53067 5.83333H16.4698Z"
        fill="inherit"
      />
    </svg>
  );
}

export default SvgArchive;
